// Same-origin requests to the server. The X-QV header marks requests as coming from the
// app itself (the server rejects writes without it, which blocks cross-site requests).
export function api(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set('X-QV', '1');
  if (init.body && typeof init.body === 'string' && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  return fetch(path, { ...init, headers, credentials: 'same-origin' });
}

export async function postJson<T = any>(path: string, body: unknown): Promise<T> {
  const r = await api(path, { method: 'POST', body: JSON.stringify(body) });
  // 400 and 429 (too many sign-in attempts) carry a message for the screen
  if (!r.ok && r.status !== 400 && r.status !== 429) throw new Error('HTTP ' + r.status);
  return r.json() as Promise<T>;
}
